<template>
  <div class="cart_modal">
    <div class="content">
      <h2>{{ $t('myCart')}}</h2>
      <div v-if="loggedIn">
        <ul v-if="this.cartProductsList.Sales_Order_Lines.length > 0" class="item_container">
          <li v-for="(item, index) in this.cartProductsList.Sales_Order_Lines" :key="item.Product_id" class="modal_card">
             <font-awesome-icon icon="times" :style="{ color: '#b6b6b6', fontSize: '18px' }" class="delete_item" @click="deleteItem(item)"/>
              <div class="modal-card-img">
                <img :src="item.Thumbnail"/>
              </div>
              <div class="cart_item_info">
                <p class="item_brand">{{item.Brand}}</p>
                <p class="item_name" v-if='$i18n.locale=="en"'>{{item.Name}}</p>
                <p class="item_name" v-if='$i18n.locale=="ch"'>{{item.Description}}</p>
                <!-- <p>Rating</p> -->
                <p class="item_price">${{item.TotalPrice}}</p>
              </div>
              <div class="cart_quant">
                <button @click="updateItemCount($event, item)" :class="item.Quantity === 1 ? 'quantity-button-one' : 'quantity-button'">-</button>
                <p class="curr-quantity">{{item.Quantity}}</p>
                <button @click="throttleAddToCart(item)" class="quantity-button">+</button>
            </div>
          </li>
        </ul>
        <div class="empty_cart" v-else>
          <h2>{{ $t('your_cart_empty') }}</h2>
          <button class="empty_cart_btn">{{$t('view_cart')}}</button>
        </div>
      </div>
      <div v-else>
        <ul v-if="this.cartProductsList.length > 0" class="item_container">
          <li v-for="(item, index) in this.cartProductsList" :key="item.Product_id" class="modal_card">
            <font-awesome-icon icon="times" :style="{ color: '#b6b6b6', fontSize: '18px' }" class="delete_item" @click="deleteItem(item)"/>
              <div class="modal-card-img">
                <img :src="item.Thumbnail"/>
              </div>
              <div class="cart_item_info">
                <p class="item_brand">{{item.Brand}}</p>
                <p class="item_name" v-if='$i18n.locale=="en"'>{{item.Name}}</p>
                <p class="item_name" v-if='$i18n.locale=="ch"'>{{item.Description}}</p>
                <!-- <p>Rating</p> -->
                <p class="item_price">${{item.Price}}</p>
              </div>
              <div class="cart_quant">
                <button @click="updateItemCount($event, item)" :class="item.quantity === 1 ? 'quantity-button-one' : 'quantity-button'">-</button>
                <p class="curr-quantity">{{item.quantity}}</p>
                <button @click="throttleAddToCart(item)" class="quantity-button">+</button>
            </div>
            <!-- <img class="delete_item" src="../assets/img/times.svg" @click="deleteItem(item)" style="cursor: pointer"/> -->

          </li>
        </ul>
        <div class="empty_cart" v-else>
          <h2>{{ $t('your_cart_empty') }}</h2>
          <button class="empty_cart_btn">{{$t('view_cart')}}</button>
        </div>
      </div>
      <div class="cart_modal_footer" v-if="cartEmpty()">
        <div class="subtotal_container">
          <p class="subtotal">{{ $t('subtotal_afm') }} {{itemCount}} {{ $t('items') }}</p>
          <p class="subtotal-cost">${{this.calculateLocalSubtotal()}}</p>
        </div>
        <button class="go_to_cart" @click="goToCart($event)">{{ $t('checkout_afm') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import moment from 'moment';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
export default {
  name: "cartModal",
  props: [
  ],
  data() {
    return {

    }
  },
  methods: {
    ...mapMutations('cart', ['toggleCartModal']),
    ...mapActions('cart', ['getCart', 'addProductToLocalCart', 'deleteCartItem', 'updateItemQuantity', 'addCart', 'saveAndAdjustCart', 'addProductToCart']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    updateItemCount(e, item) {
      e.preventDefault();
      if (isUserAuthenticated()) {
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
        this.deleteItem(item);
      } else {
        this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
        .then(() => {
          this.local = false;
          this.$store.dispatch('cart/getCart');
        });
      }
    } else {
      item.quantity = item.quantity - 1;
      if (item.quantity < 1) {
        this.deleteItem(item)
      }
      this.$store.dispatch('cart/updateLocalCart', item)
      .then(() => {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      })
    }
  },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      this.stopAddToCartLoading();
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addToCart: function(item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      // console.log('here', localStorage.getItem('warehouseLocationWeb'), localStorage.getItem('shippingMethodGlobal'))
      // if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
      //   this.toggleZipcodeModalVisibility(true);
      //   return;
      // }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    cartEmpty() {
      let valid = false;
      if (isUserAuthenticated()) {
        if (this.cartProductsList.Sales_Order_Lines.length > 0) {
          valid = true;
        }
      } else {
        if (this.cartProductsList.length > 0) {
          valid = true;
        }
      }
      return valid;
    },
    determineRating(rating) {

    },
    calculateLocalSubtotal() {
      if (!this.loggedIn) {
        let cost = 0;
         this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity;
          cost += itemPrice;
        });
        return cost.toFixed(2);
      } else {
        return (this.$store.state.cart.cartProductsList.TotalPrice - this.Savings).toFixed(2);
      }
    },
    goToCart(e) {
      e.preventDefault();
      this.$router.push('/cart')
      this.toggleCartModal(false)
    },
  },
  mounted() {
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    userDetails: state => state.auth.userDetails,
    cartModalVisible: state => state.cart.cartModalVisible,
    cartProductsList: state => state.cart.cartProductsList,
    itemCount: state => state.cart.itemCount,
    Savings: state => state.checkout.Savings,
  }),
  watch: {
    loggedIn: function(newVal, oldVal) {

    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/cartModal.less";
</style>



// WEBPACK FOOTER //
// src/view/cartModal.vue